export const textBlockDocumentationMarkdown = `
# Text Block

## What does this block do?

This block makes it easy to use text in the flow. Whatever you type into the text box can be used by subsequent blocks.

This can be plain text, text formated as markdown, as well as text with references to previous blocks and outputs using **\`{{previousBlock.data}}\`** syntax.

## When to use it?

- You want to provide static content for the flow, like a simple "Success" string
- You need to combine text and outputs from multiple blocks

## How to use

### 1. Display Static text:

~~~
Patient outreach successful
~~~

Output: \`Patient outreach successful\`

### 2. Combine text with block references:

~~~
Patient age is {{getPatientAge.data.age}}
~~~

Output: \`Patient age is 30\`

### 3. Format text with markdown:

~~~
### Patient {{patient.data.name}}
**Age:** {{patient.data.age}} | **Gender:** {{patient.data.gender}}
~~~

Output:
### Patient John Smith
**Age:** 45 | **Gender:** Male
`;
